import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/",
)({
  loader: async ({ params, parentMatchPromise }) => {
    if (
      (await parentMatchPromise).fullPath ===
      "/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId"
    ) {
      throw redirect({
        to: "/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/quantities",
        params,
      })
    }
    return null
  },
})
